import { render, staticRenderFns } from "./LoadingPrice.vue?vue&type=template&id=22107dcd&scoped=true&"
import script from "./LoadingPrice.vue?vue&type=script&lang=ts&"
export * from "./LoadingPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22107dcd",
  null
  
)

export default component.exports